import api from '@/api';
import {
  CancelConsultInvoiceResponse,
  CancelInvoiceRequest,
  ConsultInvoiceResponse,
  DataInvoiceUpdate,
  DownloadXmlInvoiceRequest,
  InvoiceCreateDTO,
  InvoiceCreateRequest,
  InvoiceDTO,
  InvoiceListParams,
  InvoiceSped,
  InvoiceSpedListRequest,
  InvoiceTefPaymentAvailabilityResponse,
  SendEmailRequest,
  UpdateInvoiceAdditionalDTO,
} from './Invoice.types';

import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;
const CONTROLLER_URL_COMMUNICATION = `invoice-communication/Invoices`;

export async function listInvoice(params?: InvoiceListParams) {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<InvoiceDTO>;
}

export async function createInvoice(obj: InvoiceCreateRequest) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as InvoiceCreateDTO;
}

export async function getInvoiceId(id: number): Promise<InvoiceCreateDTO> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;
  return result as InvoiceCreateDTO;
}

export async function deleteInvoice(id: number) {
  const result = await api.remove(`${CONTROLLER_URL}/${id}`, {}, null);

  return result;
}

export async function updateInvoice(
  obj: DataInvoiceUpdate,
): Promise<InvoiceCreateDTO> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;
  return result as InvoiceCreateDTO;
}

//Botões

export async function transmitInvoice(id: number) {
  const result = (await api.post(
    `${CONTROLLER_URL_COMMUNICATION}/${id}/transmit`,
    {},
    null,
  )) as unknown;

  return result as ConsultInvoiceResponse;
}

export async function cancelInvoice(obj: CancelInvoiceRequest) {
  const { invoiceId } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/cancel`,
    obj,
    null,
  )) as unknown;

  return result as string;
}

export async function cancelNationalNfs(invoiceId: number) {
  const result = (await api.post(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/cancel-national-nfs`,
    {},
    null,
  )) as unknown;

  return result as string;
}

export async function resolveInvoice(invoiceId: number) {
  const result = (await api.post(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/resolve`,
    {},
    null,
  )) as unknown;

  return result as string;
}

export async function sendEmailInvoice(obj: SendEmailRequest) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/send-email`,
    values,
    null,
  )) as unknown;

  return result as string;
}

export async function consultInvoice(
  id: number,
): Promise<ConsultInvoiceResponse> {
  const result = (await api.get(
    `${CONTROLLER_URL_COMMUNICATION}/${id}/situation`,
    null,
  )) as unknown;
  return result as ConsultInvoiceResponse;
}

export async function cancelConsultInvoice(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL_COMMUNICATION}/${id}/cancel/consult`,
    null,
  )) as unknown;

  return result as CancelConsultInvoiceResponse;
}

export async function invoiceDocumentDownload({
  invoiceId,
  ...params
}: DownloadXmlInvoiceRequest): Promise<BlobPart> {
  const result = (await api.getReport(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/documents/download`,
    params,
    { responseType: 'blob' },
  )) as unknown;
  return result as BlobPart;
}

export async function invoiceRpsDocument(invoiceId: number) {
  const result = (await api.getReport(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/rps-document`,
    {},
  )) as unknown;
  return result as BlobPart;
}

export async function invoiceUploadDocument(invoiceId: number) {
  const result = (await api.getReport(
    `${CONTROLLER_URL_COMMUNICATION}/${invoiceId}/upload-document`,
    {},
  )) as unknown;
  return result as BlobPart;
}

// Dados Adicionais

export async function updateInvoiceAdditional(
  obj: UpdateInvoiceAdditionalDTO,
): Promise<{
  taxAdditionalData: string;
  companyAdditionalData: string;
}> {
  const { invoiceId, ...params } = obj;

  const result = (await api.patch(
    `${CONTROLLER_URL}/invoice/${invoiceId}/additional-data`,
    params,
    null,
  )) as unknown;
  return result as {
    taxAdditionalData: string;
    companyAdditionalData: string;
  };
}

export async function invoiceTefPaymentMethod(invoiceId?: number) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/payment-method`,
    {},
  )) as unknown;
  return result as void;
}

export async function invoiceTefPaymentAvailability(invoiceId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/tef-payment-availability`,
    null,
  )) as unknown;
  return result as InvoiceTefPaymentAvailabilityResponse;
}

export async function invoiceSpedList(params: InvoiceSpedListRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/sped/reduced-invoices`,
    params,
  )) as unknown;
  return result as InvoiceSped[];
}
